module.exports = __webpack_public_path__ + "static/media/the-generic-band.6352d51f.jpg";